var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"cv-header-nav bx--header__nav"},[_c('ul',{staticClass:"bx--header__menu-bar",attrs:{"role":"menubar","ariaLabeldBy":_vm.ariaLabelledBy}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }